module.exports = __webpack_public_path__ + "img/Flag_of_Cuba.cce92c75.svg";